<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { computed, defineEmits, defineProps, ref } from "vue";
import TextInput from "@/components/inputs/TextInput.vue";
import ConfirmButton from "@/views/Auth/components/ConfirmButton.vue";

defineProps<{
  waitApiCall: boolean;
}>();
const emits = defineEmits<{
  (e: "forgotPassword", email: string): void;
}>();

const { t } = useI18n();

const email = ref<string>("");

const isCredentialsValid = computed(() => {
  const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  return emailRe.test(email.value);
});
</script>

<template>
  <TextInput
    :label="t('auth.email')"
    v-model="email"
    type="email"
    class="mb-4"
  />
  <p class="text-muted text-sm text-left select-none mb-10">
    {{ t("auth.forgot-password-tip") }}
  </p>

  <ConfirmButton
    :disabled="!isCredentialsValid || waitApiCall"
    :loading="waitApiCall"
    :button-text="t('buttons.auth.send-email')"
    @click="emits('forgotPassword', email)"
  />
</template>
